module.exports = __webpack_public_path__ + "img/logo-la-profe-cris.4cd822c9.webp";